import {Timestamp} from 'firebase/firestore'
import {JsonProperty} from 'json-object-mapper'

export const ROLE_ADMIN = 'ADMIN'
export const ROLE_USER = 'USER'

export class User {
  @JsonProperty()
  public id: string
  @JsonProperty()
  public firstName: string
  @JsonProperty()
  public lastName: string
  @JsonProperty()
  public email: string
  @JsonProperty()
  public avatar?: string
  @JsonProperty()
  public role: string = ROLE_USER
  @JsonProperty()
  public createdAt: Timestamp
  @JsonProperty()
  public countryCode?: string
  @JsonProperty()
  public countriesCode: string[]
  @JsonProperty()
  public simulationsCount: number

  isAdmin() {
    return this.role === ROLE_ADMIN
  }

  displayName() {
    return `${this.firstName} ${this.lastName}`
  }

  getCountries() {
    return this.countriesCode.map(c => [c]) || []
  }
}
